/**
 * @generated SignedSource<<5ed44481582b9034ed13bbc2a81158a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatMessage_Message$data = {
  readonly createdAt: string;
  readonly id: string;
  readonly label: string | null | undefined;
  readonly message: string;
  readonly sender: {
    readonly " $fragmentSpreads": FragmentRefs<"ChatThreadItem_Contact">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadItem_ChatMessage">;
  readonly " $fragmentType": "ChatMessage_Message";
};
export type ChatMessage_Message$key = {
  readonly " $data"?: ChatMessage_Message$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatMessage_Message">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatMessage_Message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatThreadItem_ChatMessage"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "sender",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ChatThreadItem_Contact"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChatMessage",
  "abstractKey": null
};

(node as any).hash = "9f97e76b22f42c338db0f72acf647b57";

export default node;
